import { LANDING_OFFER_FROM_META_KEY } from "../constants.js";
import { useEffect } from "react";
import { isOfMetaOrigin } from "../utils/marketing-url-params.js";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
import useGlobalContext from "./useGlobalContext.js";
import { useSelector } from "react-redux";
import { getFlightDetailsFetchStatus } from "../store/flightDetails/selectors.js";
import { getMetaFlightDetailsSlice } from "../store/metaFlightDetails/selectors.js";
import useEvents from "./useEvents.js";
export default function useLogFORAPErrors(offerToken) {
    const isMetaUser = isOfMetaOrigin();
    const landingMetaOffer = flightsSessionStore.get(LANDING_OFFER_FROM_META_KEY);
    const { userAgent } = useGlobalContext();
    const flightDetailsFetchStatus = useSelector(getFlightDetailsFetchStatus);
    const metaFlightDetails = useSelector(getMetaFlightDetailsSlice);
    const { grumble } = useEvents();
    useEffect(() => {
        if (isMetaUser && landingMetaOffer == offerToken) {
            if (flightDetailsFetchStatus === "success" && ["success", "failed"].includes(metaFlightDetails.fetchStatus)) {
                if (!metaFlightDetails.flight) {
                    grumble(`FD success, FORAP failed for ${userAgent.isBot ? "bot" : "normal"} : ${isMetaUser}`, {
                        url: `${location.href}&ext-origin=${isMetaUser}`
                    });
                }
            }
            else if (flightDetailsFetchStatus === "failed" &&
                ["success", "failed"].includes(metaFlightDetails.fetchStatus)) {
                if (metaFlightDetails.flight) {
                    grumble(`FD failed, FORAP success for ${userAgent.isBot ? "bot" : "normal"} : ${isMetaUser}`, {
                        url: `${location.href}&ext-origin=${isMetaUser}`
                    });
                }
                else {
                    grumble(`FD and FORAP failed for ${userAgent.isBot ? "bot" : "normal"} : ${isMetaUser}`, {
                        url: `${location.href}&ext-origin=${isMetaUser}`
                    });
                }
            }
        }
    }, [flightDetailsFetchStatus]);
}
